export default "__VITE_ASSET__FWSO3WUL__"